import React from 'react';
import { Icon } from 'antd';

import formatPrice from '~helpers/currency';

import Card from '../card';

export default function ProductInfo({
  t,
  productInfo = {},
  showExtra = false,
  setVisibleModal = () => {},
}) {
  const productInfoFields = [
    {
      label: t('landlord.booking.reconciliation.details.property.label'),
      value: productInfo?.propertyName,
    },
    {
      label: t('landlord.booking.reconciliation.details.room.label'),
      value: productInfo?.unitTypeName,
    },
    {
      label: t('landlord.booking.reconciliation.details.listing_price.label'),
      value: productInfo?.listingSalesPrice
        ? formatPrice(productInfo.listingSalesPrice, productInfo?.currency)
        : '-',
    },
  ];

  return (
    <Card
      id="product_info"
      title={t('landlord.booking.reconciliation.details.product_info.title')}
      dataSet={productInfoFields}
      extra={
        showExtra && (
          <Icon onClick={() => setVisibleModal(true)} type="edit" style={{ color: '#38b2a6' }} />
        )
      }
    />
  );
}
